// extracted by mini-css-extract-plugin
module.exports = {"Text":"Text_Text__3jAyx","Value":"Text_Value__3Ia9d","Small":"Text_Small__34081","Unit":"Text_Unit__cZHfI"};